export default "__VITE_ASSET__CIO88ujS__$_?nuxt_component=async&nuxt_component_name=IconFielmannLogoCZ&nuxt_component_export=default__"